import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const css = `
.rep-wrap{display:grid;grid-template-columns:240px 1fr;gap:16px;}
.rep-menu{background:var(--surface);border-radius:10px;border:1px solid var(--border);overflow:hidden;}
.rep-menu-hdr{padding:12px 16px;background:var(--navy);color:#fff;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.4px;}
.rep-item{padding:10px 16px;cursor:pointer;border-bottom:1px solid var(--bg);font-size:12px;display:flex;align-items:center;gap:10px;transition:background .1s;}
.rep-item:hover{background:var(--blue-lt);}
.rep-item.active{background:var(--navy);color:#fff;}
.rep-item-icon{font-size:16px;width:20px;text-align:center;}
.rep-panel{background:var(--surface);border-radius:10px;border:1px solid var(--border);overflow:hidden;}
.rep-panel-hdr{padding:12px 18px;background:var(--navy);color:#fff;font-size:13px;font-weight:700;}
.rep-panel-body{padding:20px;}
.rep-form{display:grid;grid-template-columns:1fr 1fr;gap:14px 20px;}
.rep-full{grid-column:1/-1;}
/* Notificaciones */
.notif-bell{position:relative;cursor:pointer;padding:6px;border-radius:50%;transition:background .15s;}
.notif-bell:hover{background:var(--blue-lt);}
.notif-badge{position:absolute;top:0;right:0;width:16px;height:16px;background:var(--red);color:#fff;border-radius:50%;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;}
.notif-panel{position:absolute;top:100%;right:0;width:340px;background:#fff;border-radius:10px;border:1px solid var(--border);box-shadow:0 8px 24px rgba(0,0,0,.15);z-index:100;overflow:hidden;}
.notif-hdr{padding:10px 14px;background:var(--navy);color:#fff;font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:space-between;}
.notif-item{padding:8px 14px;border-bottom:1px solid var(--bg);font-size:11px;}
.notif-item:hover{background:var(--blue-lt);}
`;

const REPORTES = [
  { id:'lista-pacientes',  icon:'👥', label:'Lista de pacientes'  },
  { id:'turnos-dia',       icon:'📅', label:'Turnos del dia'      },
  { id:'produccion-medica',icon:'📊', label:'Produccion medica'   },
];

/* ── Notificaciones ──────────────────────────────────── */
function Notificaciones() {
  const [open,    setOpen]    = useState(false);
  const [notifs,  setNotifs]  = useState(null);
  const [loading, setLoading] = useState(false);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      // Obtener usuario del token
      const token = localStorage.getItem('token');
      if (!token) return;
      const payload = JSON.parse(atob(token.split('.')[1]));
      const { data } = await api.get(`/dashboard/notificaciones?medico=${payload.usuario}`);
      setNotifs(data);
    } catch {}
    finally { setLoading(false); }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const pendientes = notifs?.resumen?.pendientes || 0;

  return (
    <div style={{ position:'relative' }}>
      <div className="notif-bell" onClick={() => { setOpen(o => !o); if (!open) cargar(); }}>
        <span style={{ fontSize: 20 }}>🔔</span>
        {pendientes > 0 && (
          <span className="notif-badge">{pendientes > 99 ? '99+' : pendientes}</span>
        )}
      </div>

      {open && (
        <div className="notif-panel">
          <div className="notif-hdr">
            <span>Mis turnos hoy</span>
            <span style={{ cursor:'pointer', opacity:.7 }} onClick={() => setOpen(false)}>✕</span>
          </div>

          {loading && (
            <div style={{ padding:'16px', textAlign:'center', color:'var(--text3)', fontSize:12 }}>Cargando...</div>
          )}

          {!loading && notifs && (
            <>
              {/* Resumen */}
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:1, borderBottom:'1px solid var(--border)' }}>
                {[
                  ['Total', notifs.resumen?.total || 0,    '#1565C0'],
                  ['Atendidos', notifs.resumen?.atendidos || 0, '#388E3C'],
                  ['Pendientes', notifs.resumen?.pendientes || 0, '#E65100'],
                ].map(([l,v,c]) => (
                  <div key={l} style={{ padding:'10px', textAlign:'center', background:'var(--bg)' }}>
                    <div style={{ fontSize:18, fontWeight:700, color:c }}>{v}</div>
                    <div style={{ fontSize:10, color:'var(--text3)' }}>{l}</div>
                  </div>
                ))}
              </div>

              {/* Lista de turnos */}
              <div style={{ maxHeight:240, overflowY:'auto' }}>
                {notifs.turnos?.length === 0 && (
                  <div style={{ padding:'16px', textAlign:'center', color:'var(--text3)', fontSize:12 }}>
                    Sin turnos para hoy
                  </div>
                )}
                {notifs.turnos?.map((t, i) => {
                  const colors = { PRG:'#6C9BD2', FIN:'#5BAD8F', ANL:'#EF9A9A', ATN:'#29B6F6', AUS:'#7B1FA2' };
                  return (
                    <div key={i} className="notif-item">
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <span style={{ width:8, height:8, borderRadius:'50%', background:colors[t.C_ESTADO]||'#ccc', flexShrink:0 }} />
                        <div>
                          <div style={{ fontWeight:600 }}>#{t.NUMERO} {t.HORA && `· ${t.HORA}`} — {t.PACIENTE}</div>
                          <div style={{ color:'var(--text3)', fontSize:10 }}>{t.SERVICIO}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div style={{ padding:'8px 14px', borderTop:'1px solid var(--border)', fontSize:11, color:'var(--text3)', textAlign:'center' }}>
                {notifs.fecha}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

/* ── Helper descarga ─────────────────────────────────── */
async function descargar(url, filename) {
  const token = localStorage.getItem('token');
  const res   = await fetch(`${(process.env.REACT_APP_API_URL||'http://localhost:3001/api')}${url}`,
    { headers: { Authorization:`Bearer ${token}` } });
  if (!res.ok) throw new Error('Error generando reporte');
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
}

/* ── Panel Lista Pacientes ───────────────────────────── */
function ReportePacientes() {
  const [form, setForm] = useState({ q:'', sexo:'' });
  const [loading, setLoading] = useState(false);
  const [loadingXls, setLoadingXls] = useState(false);

  const generar = async (formato='pdf') => {
    formato==='pdf' ? setLoading(true) : setLoadingXls(true);
    try {
      const params = new URLSearchParams({ q:form.q, sexo:form.sexo, formato }).toString();
      await descargar(`/reportes/lista-pacientes?${params}`,
        formato==='xlsx' ? 'Lista_Pacientes.xlsx' : 'Lista_Pacientes.pdf');
    } catch(e) { alert(e.message); }
    finally { formato==='pdf' ? setLoading(false) : setLoadingXls(false); }
  };

  return (
    <div className="rep-form">
      <div>
        <label className="form-label">Buscar (nombre o cedula)</label>
        <input className="form-control" placeholder="Todos los pacientes si esta vacio"
          value={form.q} onChange={e => setForm(f => ({...f, q:e.target.value}))} />
      </div>
      <div>
        <label className="form-label">Sexo</label>
        <select className="form-control" value={form.sexo} onChange={e => setForm(f => ({...f, sexo:e.target.value}))}>
          <option value="">Todos</option>
          <option value="M">Masculino</option>
          <option value="F">Femenino</option>
        </select>
      </div>
      <div className="rep-full">
        <div style={{ background:'var(--blue-lt)', borderRadius:8, padding:'10px 14px', fontSize:12, color:'var(--navy)', marginBottom:16 }}>
          ℹ️ Genera un PDF con la lista completa de pacientes activos según los filtros seleccionados. Maximo 5,000 registros.
        </div>
        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-primary" disabled={loading} onClick={()=>generar('pdf')} style={{ minWidth:140 }}>
            {loading ? 'Generando...' : '⬇ PDF'}
          </button>
          <button className="btn btn-sm" style={{background:'#1D6F42',color:'#fff',border:'none',minWidth:140}}
            disabled={loadingXls} onClick={()=>generar('xlsx')}>
            {loadingXls ? 'Generando...' : '⬇ Excel'}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Panel Turnos del Dia ────────────────────────────── */
function ReporteTurnos({ medicos }) {
  const hoy  = new Date().toISOString().slice(0,10);
  const [form, setForm] = useState({ fecha:hoy, medico:'' });
  const [loading, setLoading] = useState(false);

  const [loadingXls, setLoadingXls] = useState(false);
  const generar = async (formato='pdf') => {
    formato==='pdf' ? setLoading(true) : setLoadingXls(true);
    try {
      const params = new URLSearchParams({ fecha:form.fecha, medico:form.medico, formato }).toString();
      await descargar(`/reportes/turnos-dia?${params}`,
        formato==='xlsx' ? `Turnos_${form.fecha}.xlsx` : `Turnos_${form.fecha}.pdf`);
    } catch(e) { alert(e.message); }
    finally { formato==='pdf' ? setLoading(false) : setLoadingXls(false); }
  };

  return (
    <div className="rep-form">
      <div>
        <label className="form-label">Fecha</label>
        <input type="date" className="form-control" value={form.fecha}
          onChange={e => setForm(f => ({...f, fecha:e.target.value}))} />
      </div>
      <div>
        <label className="form-label">Medico</label>
        <select className="form-control" value={form.medico}
          onChange={e => setForm(f => ({...f, medico:e.target.value}))}>
          <option value="">Todos los medicos</option>
          {medicos.map(m => <option key={m.USUARIO} value={m.USUARIO}>{m.NOMBRES}</option>)}
        </select>
      </div>
      <div className="rep-full">
        <div style={{ background:'var(--blue-lt)', borderRadius:8, padding:'10px 14px', fontSize:12, color:'var(--navy)', marginBottom:16 }}>
          ℹ️ Lista de todos los turnos del dia seleccionado con hora, paciente, estado y convenio.
        </div>
        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-primary" disabled={loading} onClick={()=>generar('pdf')} style={{ minWidth:140 }}>
            {loading ? 'Generando...' : '⬇ PDF'}
          </button>
          <button className="btn btn-sm" style={{background:'#1D6F42',color:'#fff',border:'none',minWidth:140}}
            disabled={loadingXls} onClick={()=>generar('xlsx')}>
            {loadingXls ? 'Generando...' : '⬇ Excel'}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Panel Produccion Medica ─────────────────────────── */
function ReporteProduccion({ medicos }) {
  const hoy      = new Date().toISOString().slice(0,10);
  const primerDia = hoy.slice(0,8) + '01';
  const [form, setForm] = useState({ fecha_desde:primerDia, fecha_hasta:hoy });
  const [loading, setLoading] = useState(false);

  const [loadingXls, setLoadingXls] = useState(false);
  const generar = async (formato='pdf') => {
    formato==='pdf' ? setLoading(true) : setLoadingXls(true);
    try {
      const params = new URLSearchParams({ fecha_desde:form.fecha_desde, fecha_hasta:form.fecha_hasta, formato }).toString();
      await descargar(`/reportes/produccion-medica?${params}`,
        formato==='xlsx' ? `Produccion_${form.fecha_desde}_${form.fecha_hasta}.xlsx` : `Produccion_${form.fecha_desde}_${form.fecha_hasta}.pdf`);
    } catch(e) { alert(e.message); }
    finally { formato==='pdf' ? setLoading(false) : setLoadingXls(false); }
  };

  return (
    <div className="rep-form">
      <div>
        <label className="form-label">Fecha desde</label>
        <input type="date" className="form-control" value={form.fecha_desde}
          onChange={e => setForm(f => ({...f, fecha_desde:e.target.value}))} />
      </div>
      <div>
        <label className="form-label">Fecha hasta</label>
        <input type="date" className="form-control" value={form.fecha_hasta}
          onChange={e => setForm(f => ({...f, fecha_hasta:e.target.value}))} />
      </div>
      <div className="rep-full">
        <div style={{ background:'var(--blue-lt)', borderRadius:8, padding:'10px 14px', fontSize:12, color:'var(--navy)', marginBottom:16 }}>
          ℹ️ Resumen de turnos por medico en el periodo: total agendados, atendidos, cancelados, ausentes y porcentaje de asistencia.
        </div>
        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-primary" disabled={loading} onClick={()=>generar('pdf')} style={{ minWidth:140 }}>
            {loading ? 'Generando...' : '⬇ PDF'}
          </button>
          <button className="btn btn-sm" style={{background:'#1D6F42',color:'#fff',border:'none',minWidth:140}}
            disabled={loadingXls} onClick={()=>generar('xlsx')}>
            {loadingXls ? 'Generando...' : '⬇ Excel'}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Pagina Principal ────────────────────────────────── */
export default function Reportes() {
  const [activo,  setActivo]  = useState('lista-pacientes');
  const [medicos, setMedicos] = useState([]);

  useEffect(() => {
    api.get('/catalogos/medicos').then(r => setMedicos(r.data)).catch(() => {});
  }, []);

  const reporte = REPORTES.find(r => r.id === activo);

  return (
    <>
      <style>{css}</style>
      <div className="fade-up">
        {/* Notificaciones — widget flotante arriba a la derecha */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
          <h2 style={{ fontSize:16, fontWeight:700, color:'var(--text)', margin:0 }}>Reportes</h2>
          <Notificaciones />
        </div>

        <div className="rep-wrap">
          {/* Menu lateral */}
          <div className="rep-menu">
            <div className="rep-menu-hdr">Reportes disponibles</div>
            {REPORTES.map(r => (
              <div key={r.id} className={`rep-item ${activo===r.id?'active':''}`} onClick={() => setActivo(r.id)}>
                <span className="rep-item-icon">{r.icon}</span>
                <span>{r.label}</span>
              </div>
            ))}
          </div>

          {/* Panel del reporte seleccionado */}
          <div className="rep-panel">
            <div className="rep-panel-hdr">
              {reporte?.icon} {reporte?.label}
            </div>
            <div className="rep-panel-body">
              {activo === 'lista-pacientes'   && <ReportePacientes />}
              {activo === 'turnos-dia'         && <ReporteTurnos medicos={medicos} />}
              {activo === 'produccion-medica'  && <ReporteProduccion medicos={medicos} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
